var Collection, Modelize;

Modelize = function(self, options) {
  var api_name, id_param, index, name, _ref, _ref1;
  self.api = function() {
    return options.api;
  };
  if (options.editable != null) {
    _ref = options.editable;
    for (index in _ref) {
      name = _ref[index];
      Editable(self, name, (function(_this) {
        return function(value, prop) {
          var edit_value;
          edit_value = {};
          edit_value[prop] = value;
          return self.update(edit_value);
        };
      })(this));
    }
  }
  if (options.has_many != null) {
    _ref1 = options.has_many;
    for (index in _ref1) {
      name = _ref1[index];
      id_param = name + '_id';
      api_name = name + 's';
      self[name + 's'] = (function(_this) {
        return function(params, callback) {
          if (params == null) {
            params = {};
          }
          if (options.belongs_to != null) {
            return self.api()[api_name].read(options.belongs_to, self.id, params).done(callback);
          } else {
            return self.api()[api_name].read(self.id, params).done(callback);
          }
        };
      })(this);
      self[name + '_add'] = (function(_this) {
        return function(id, callback) {
          var params;
          params = {};
          params[id_param] = id;
          if (options.belongs_to != null) {
            return self.api()[api_name].create(options.belongs_to, self.id, params).done(callback);
          } else {
            return self.api()[api_name].create(self.id, params).done(callback);
          }
        };
      })(this);
      self[name + '_update'] = (function(_this) {
        return function(id, params, callback) {
          if (options.belongs_to != null) {
            return self.api()[api_name].update(options.belongs_to, self.id, id, params).done(callback);
          } else {
            return self.api()[api_name].update(self.id, id, params).done(callback);
          }
        };
      })(this);
      self[name + '_delete'] = (function(_this) {
        return function(id, callback) {
          if (options.belongs_to != null) {
            return self.api()[api_name].destroy(options.belongs_to, self.id, id).done(callback);
          } else {
            return self.api()[api_name].destroy(self.id, id).done(callback);
          }
        };
      })(this);
    }
  }
  self.update = function(data, callback) {
    if (options.belongs_to != null) {
      return self.api().update(options.belongs_to, self.id, data).done(callback);
    } else {
      return self.api().update(self.id, data).done(callback);
    }
  };
  self["delete"] = function(callback) {
    if (options.belongs_to != null) {
      return self.api().destroy(options.belongs_to, self.id).done(callback);
    } else {
      return self.api().destroy(self.id).done(callback);
    }
  };
  return self;
};

Collection = function(model, mapi) {
  model.find = function(params, options, callback) {
    return mapi.read(params, options).done(callback);
  };
  return model.create = function(params, options, callback) {
    return mapi.create(params, options).done(callback);
  };
};

//# sourceMappingURL=model.js.map
